
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/photo",
      function () {
        return require("private-next-pages/media/photo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/photo"])
      });
    }
  